import { render, staticRenderFns } from "./goodsWeappAttr.vue?vue&type=template&id=24ca6f65&scoped=true"
import script from "./goodsWeappAttr.vue?vue&type=script&lang=js"
export * from "./goodsWeappAttr.vue?vue&type=script&lang=js"
import style0 from "./goodsWeappAttr.vue?vue&type=style&index=0&id=24ca6f65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca6f65",
  null
  
)

component.options.__file = "goodsWeappAttr.vue"
export default component.exports